import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useTabsState } from '_common/hooks';

import { setCurrentAppPage } from 'App/redux/appSlice';

import { IntlErrorBoundary } from '_common/components';
import { Tabs } from '@ets/design-system';
import { ActionBar } from '_common/components';

import UserProfile from './UserProfile/UserProfile';
import UserSecurity from './UserSecurity/UserSecurity';
import Authentication from './Authentication/Authentication';
import UserNotifications from './UserNotifications/UserNotifications';

import styles from './UserSettingsPage.module.scss';

const UserSettingsPage = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { tab, onTabChange } = useTabsState('userSettingsPage');

  useEffect(() => {
    dispatch(setCurrentAppPage('/settings/user'));
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <IntlErrorBoundary size="s" style={{ margin: '0 0 0 7rem' }}>
          <ActionBar>
            <ActionBar.Breadcrumb
              path={[
                {
                  id: 'users',
                  name: intl.formatMessage({ id: 'global.userPreferences' }),
                },
              ]}
              testId="user-settings-page"
            />
          </ActionBar>
        </IntlErrorBoundary>
      </div>
      <div className={styles.page}>
        <IntlErrorBoundary size="xl" style={{ margin: '13.5rem 0 0 0' }}>
          <Tabs
            value={tab || 'user-preferences-general'}
            onValueChange={onTabChange}
            className={styles.tabs}
          >
            <Tabs.List>
              <Tabs.Trigger value="user-preferences-general">
                {intl.formatMessage({ id: 'settings.tabs.general' })}
              </Tabs.Trigger>
              <Tabs.Trigger value="user-preferences-notifications">
                {intl.formatMessage({ id: 'NOTIFICATIONS' })}
              </Tabs.Trigger>
              <Tabs.Trigger value="user-preferences-security">
                {intl.formatMessage({ id: 'settings.tabs.security' })}
              </Tabs.Trigger>
              <Tabs.Trigger value="user-preferences-authentication">
                {intl.formatMessage({ id: 'settings.tabs.authentication' })}
              </Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="user-preferences-general" className={styles.content}>
              <IntlErrorBoundary
                key="user-preferences-general"
                size="xl"
                style={{ margin: '5rem 0' }}
              >
                <UserProfile />
              </IntlErrorBoundary>
            </Tabs.Content>
            <Tabs.Content value="user-preferences-notifications" className={styles.content}>
              <IntlErrorBoundary
                key="user-preferences-notifications"
                size="xl"
                style={{ margin: '5rem 0' }}
              >
                <UserNotifications />
              </IntlErrorBoundary>
            </Tabs.Content>
            <Tabs.Content value="user-preferences-security" className={styles.content}>
              <IntlErrorBoundary
                key="user-preferences-security"
                size="xl"
                style={{ margin: '5rem 0' }}
              >
                <UserSecurity />
              </IntlErrorBoundary>
            </Tabs.Content>
            <Tabs.Content value="user-preferences-authentication" className={styles.content}>
              <IntlErrorBoundary
                key="user-preferences-authentication"
                size="xl"
                style={{ margin: '5rem 0' }}
              >
                <Authentication />
              </IntlErrorBoundary>
            </Tabs.Content>
          </Tabs>
        </IntlErrorBoundary>
      </div>
    </div>
  );
};

export default UserSettingsPage;
